import React, {
  useRef,
} from 'react';
import {
  InsuranceDTO,
} from 'dtos';
import Tooltip, {
  Props as TooltipProps,
} from 'core/components/Tooltip';
import clsx from 'clsx';
import CircleIcon from '@mui/icons-material/CircleRounded';

type Props = InsuranceDTO & {
  className?: string;
  tooltip?: Pick<TooltipProps, 'title' | 'placement'>;
  invalid?: boolean;
};

export default function InsuranceChip({
  insuranceName,
  className,
  tooltip,
  invalid = false,
}: Props) {
  const labelRef = useRef<HTMLDivElement>(null);
  return (
    <div className={clsx(
      'overflow-x-hidden w-full truncate insurance-chip bg-gray-200 text-gray-700 rounded-full px-3',
      className,
    )}
    >
      <Tooltip
        title={tooltip?.title ?? insuranceName}
        ref={labelRef}
        placement={tooltip?.placement}
        auto={typeof tooltip === 'undefined'}
      >
        <div
          ref={labelRef}
          className={clsx('truncate', { 'flex items-center gap-1': invalid })}
        >
          {invalid ? (
            <>
              <CircleIcon className="!h-2.5 !w-2.5 shrink-0 !text-red-600" />
              <span className="truncate">{insuranceName}</span>
            </>
          ) : insuranceName}
        </div>
      </Tooltip>
    </div>
  );
}
